import { render } from "./serviceQuestion.vue?vue&type=template&id=01b54f89&scoped=true"
import script from "./serviceQuestion.vue?vue&type=script&lang=js"
export * from "./serviceQuestion.vue?vue&type=script&lang=js"

import "./serviceQuestion.vue?vue&type=style&index=0&id=01b54f89&scoped=true&lang=css"

import exportComponent from "/Users/leaf/Desktop/gmhwork/h5/zksq_H5/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-01b54f89"]])

export default __exports__